<template>
  <div class="d-flex flex-column">
    <!-- UPLOAD -->
    <div v-if="(!video || !video.id) && !isInitializing && !isUploading" class="upload p-5">
      <input
        type="file"
        ref="actualVideoInput"
        accept="video/*,.mkv"
        class="d-none"
        @change="upload(uploadApproachTypes.post)"
      />
      <div
        class="upload-via-drag"
        @click="chooseVideo"
        @dragover="onDragover"
        @dragleave="onDragLeave"
        @drop="uploadDroppedVideo"
      >
        <div class="banner">
          <b-icon-cloud-arrow-up class="upload-icon" />
          <span class="prompt">Перетащите видео сюда или нажмите, чтобы открыть диалог загрузки</span>
        </div>
      </div>
      <div class="text-center">
        <!-- <span>или</span>
        <div class="d-flex">
          <b-form-input size="sm" placeholder="Загрузить по ссылке с YouTube" v-model.trim="link" />
          <b-button
            variant="outline-primary"
            class="ml-3 flex-grow-1"
            size="sm"
            @click="upload(uploadApproachTypes.pull)"
            >Загрузить</b-button
          >
        </div> -->
        <span>или</span>
        <div class="d-flex">
          <b-form-input
            size="sm"
            placeholder="Прикрепить по ссылке с YouTube (без загрузки)"
            v-model.trim="attachLink"
          />
          <b-button
            variant="outline-primary"
            class="ml-3 flex-grow-1"
            size="sm"
            @click="upload(uploadApproachTypes.addIframe)"
            >Прикрепить</b-button
          >
        </div>
        <span>или</span>
        <project-video-list @input="addUploadedVideo" />
      </div>
    </div>
    <!-- SHOW -->
    <div class="video">
      <template v-if="isInitializing">
        <div class="d-flex p-3">
          <b-spinner variant="primary" small class="mx-auto" />
        </div>
      </template>
      <template v-else-if="isUploading">
        <div class="d-flex flex-column p-3">
          <span class="mb-1"
            >Загрузка "<span class="font-weight-bold">{{ video.name }}</span
            >"</span
          >
          <b-progress v-if="uploadApproach === uploadApproachTypes.post && progress < 100" :value="progress" animated />
          <b-spinner v-else variant="primary" class="mx-auto" small />
        </div>
      </template>
      <template v-else-if="video.id">
        <div class="d-flex align-items-center justify-content-between">
          <b-form-input v-model="video.name" class="ml-3 p-0 border-0" @input="saveName" />
        </div>
        <div v-if="video.is_queued" class="px-3 pb-3">
          Видео загружается, пожалуйста, подождите. Обычно этот процесс занимает не более 10 минут.
        </div>
        <div v-else>
          <div v-if="showSettingPreview" class="vimeo-preview border-top border-bottom p-3">
            <label class="font-weight-bold">Превью для видео</label>
            <div class="d-flex align-items-center mb-2">
              <b-form-timepicker
                style="width: 120px"
                title="Время кадра для превью"
                v-model="frame_time"
                no-close-button
                show-seconds
              />
              <b-button class="ml-3" variant="outline-primary" @click="setPreview">Установить время</b-button>
              <span class="mx-3">или</span>
              <b-form-file
                :id="video.id + ''"
                class="d-none"
                v-model="preview"
                accept=".jpeg, .jpg, .png"
                @input="uploadPreview"
              />
              <b-button variant="outline-primary" @click="choosePreview">Загрузить свое изображение</b-button>
            </div>
          </div>
          <div v-if="video.is_ready" class="embed-container">
            <iframe
              :key="iframeResetCnt"
              allowfullscreen
              :src="video.iframe_src"
              frameborder="0"
              :class="{ 'no-pointer-events': isDragging }"
            />
          </div>
          <div v-else class="p-3 d-flex align-items-center justify-content-center">
            Видео ещё обрабатывается. Обычно это занимает не больше 10 минут
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.no-pointer-events {
  pointer-events: none !important;
}

.upload {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  input {
    width: 330px;
  }
  .upload-via-drag {
    cursor: pointer;
    width: 100%;
    height: 300px;
    border: 2px dashed #adadad;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    &.drag-over {
      background-color: #eee;
      border-color: #3699ff;
    }
    .banner {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      pointer-events: none;
      .upload-icon {
        width: 100px;
        height: 100px;
        color: #e0e0e0;
      }
      .prompt {
        font-size: 1rem;
        font-weight: 500;
        max-width: 250px;
        text-align: center;
        color: #3f4254;
      }
    }
  }
}

.embed-container {
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
  height: auto;
  iframe {
    border-radius: 0 0 5px 5px;
  }
  iframe,
  object,
  embed {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}
</style>

<script>
import { BIconCloudArrowUp } from "bootstrap-vue";
import ProjectVideoList from "./ProjectVideoList.vue";
import Api from "shared/service/api/api";
import { ALLOW_UNLOAD, PREVENT_UNLOAD } from "shared/store/modules/beforeunload.store";
import { mapMutations } from "vuex";

export default {
  name: "videoUploader",
  components: { BIconCloudArrowUp, ProjectVideoList },
  props: {
    value: {
      type: Object,
      required: false,
      default: () => {},
    },
    /* Данный флаг принимает значение истины, когда какой-либо элемент дерева перетаскивается */
    isDragging: {
      type: Boolean,
      required: false,
    },
    showSettingPreview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    uploadApproachTypes: () => ({
      post: "post",
      pull: "pull",
      addIframe: "addIframe",
    }),
  },
  data() {
    return {
      video: this.value,
      isInitializing: false,
      isUploading: false,
      progress: null,
      link: null,
      attachLink: null,
      uploadApproach: null,
      saveNameTimer: null,
      frame_time: "00:00:00",
      preview: null,
      iframeResetCnt: 0,
    };
  },
  methods: {
    ...mapMutations("autocomplete/video", ["reset"]),
    saveName() {
      clearTimeout(this.saveNameTimer);
      this.saveNameTimer = setTimeout(() => {
        this.$emit("input", this.video);
      }, 1000);
    },
    chooseVideo() {
      this.$refs.actualVideoInput.click();
    },
    upload(approach) {
      this.uploadApproach = approach;

      if (
        (this.uploadApproach === this.uploadApproachTypes.pull && !this.link) ||
        (this.uploadApproach === this.uploadApproachTypes.addIframe && !this.attachLink)
      ) {
        return;
      }

      this.initializeUpload();
      const video = this.$refs.actualVideoInput.files[0];
      if (video) {
        this.postVideo(video);
        return;
      }

      this.uploadApproach === this.uploadApproachTypes.pull ? this.pullVideo() : this.addIframe();
    },
    addIframe() {
      Api.multimedia.video
        .initiateVideoAddIframe(this.attachLink)
        .then((response) => {
          this.onInitializationComplete();
          this.onUploadComplete();

          if (!response.success) {
            throw new Error(response.error);
          }

          this.video = response.data;
          this.$emit("input", this.video);
          this.reset();
        })
        .catch((e) => {
          this.$alert.error("Ошибка загрузки видео.<br>" + e.message);
          this.onUploadComplete();
        })
        .finally(() => {
          this.onInitializationComplete();
        });
    },
    pullVideo() {
      Api.multimedia.video
        .initiateVideoPull(this.link)
        .then((response) => {
          this.onInitializationComplete();
          this.onUploadComplete();

          if (!response.success) {
            throw new Error(response.error);
          }

          this.video = response.data;
          this.$emit("input", this.video);
          this.reset();
        })
        .catch((e) => {
          this.$alert.error("Ошибка загрузки видео.<br>" + e.message);
          this.onUploadComplete();
        })
        .finally(() => {
          this.onInitializationComplete();
        });
    },
    postVideo(video) {
      Api.multimedia.video
        .initiateVideoUpload(video.name, video.size)
        .then((response) => {
          // video is done initializing
          this.onInitializationComplete();

          if (!response.success) {
            this.$alert.error(response.error);
            return;
          }

          this.isUploading = true;

          const { vimeo_video_id, upload_link } = response.data;
          this.video.vimeo_video_id = vimeo_video_id;
          this.video.name = video.name;

          // actually upload the video
          const xhr = new XMLHttpRequest();
          xhr.open("PATCH", upload_link, true);
          xhr.setRequestHeader("Content-Type", "application/offset+octet-stream");
          xhr.setRequestHeader("Tus-Resumable", "1.0.0");
          xhr.setRequestHeader("Upload-Offset", "0");

          // update the progress bar
          xhr.upload.addEventListener("progress", ({ loaded, total }) => {
            this.progress = (loaded / total) * 100;
            this.$forceUpdate();
          });

          // after uploading, POST to the edeone api to save video info
          xhr.onload = () => {
            Api.multimedia.video
              .saveVimeoVideo(vimeo_video_id, video.name)
              .then((response) => {
                if (!response.success) {
                  throw new Error(response.error);
                }

                this.video = response.data;
                this.$emit("input", this.video);
                this.reset();
              })
              .catch((e) => {
                this.$alert.error("Ошибка сохранения видео<br>" + e.message);
              })
              .finally(() => {
                this.onUploadComplete();
              });
          };

          // show error to the user
          xhr.onerror = (e) => {
            this.onUploadComplete();
            this.$alert.error("Произошла ошибка при загрузке видео<br>" + e.message);
          };

          xhr.send(video);
        })
        .finally(() => {
          // not gonna hurt
          this.onInitializationComplete();
        });
    },
    initializeUpload() {
      this.isInitializing = true;
      this.$store.dispatch(PREVENT_UNLOAD);
    },
    onInitializationComplete() {
      this.isInitializing = false;
    },
    onUploadComplete() {
      this.isUploading = false;
      this.uploadApproach = null;
      this.link = null;
      this.attachLink = null;
      this.$store.dispatch(ALLOW_UNLOAD);
    },
    onDragover(e) {
      if (!e.dataTransfer.items || !e.dataTransfer.items.length) {
        e.preventDefault();
        return;
      }

      e.target.classList.add("drag-over");
    },
    onDragLeave(e) {
      if (!e.dataTransfer.items || !e.dataTransfer.items.length) {
        e.preventDefault();
        return;
      }

      e.target.classList.remove("drag-over");
    },
    uploadDroppedVideo(e) {
      if (!e.dataTransfer.items || !e.dataTransfer.items.length) {
        e.preventDefault();
        return;
      }

      this.onDragLeave(e);
      e.preventDefault();

      if (e.dataTransfer.items && e.dataTransfer.items.length) {
        this.initializeUpload();
        this.uploadApproach = this.uploadApproachTypes.post;
        this.postVideo(e.dataTransfer.items[0].getAsFile());
      } else {
        this.$alert.error("Ошибка. Свяжитесь с разработчиками.");
      }
    },
    addUploadedVideo(video) {
      if (!video) {
        return;
      }

      this.video = {
        id: video.id,
        name: video.name,
        iframe_src: video.iframe_src,
        is_queued: !video.iframe_src,
      };
      this.$emit("input", this.video);
    },
    setPreview() {
      Api.multimedia.video
        .setVimeoPreview(this.video.id, this.frame_time)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }
          this.iframeResetCnt++;
        })
        .catch((e) => this.$alert.error(e.message));
    },
    choosePreview() {
      document.getElementById(this.video.id).click();
    },
    uploadPreview() {
      if (!this.preview) {
        return;
      }

      Api.multimedia.video
        .uploadVimeoPreview(this.video.id, this.preview)
        .then((response) => {
          if (!response.success) {
            throw new Error(response.error);
          }
          this.iframeResetCnt++;
        })
        .catch((e) => this.$alert.error(e.message));
      this.preview = null;
    },
  },
};
</script>
